export default "__VITE_ASSET__57000591__"